import * as ISchema from "@schema";
import { DateTime } from "luxon";

import { getValue } from "@clockwise/web-commons/src/util/errorable.util";
import { getTrialMetadataFromOrg } from "@src/util/feature-grid.util";

export const isUserOnTrial = (_org: ISchema.IOrg) => {
  const featureGrid = getValue(_org.featureGrid);
  if (featureGrid?.stateMetadata && featureGrid.stateMetadata.userMetadata) {
    return !!featureGrid.stateMetadata.userMetadata.trialMetadata;
  } else {
    return false;
  }
};

// This currenty wil return a Duration Object from Luxon containing the number of days
export const getCurrentDurationRemainingOnTrial = (
  trialMetadata: ISchema.ITrialMetadata | null,
  altCurrentDateTime?: DateTime,
) => {
  if (!trialMetadata || !trialMetadata.timeZone || !trialMetadata.trialEndDate) {
    console.error("The correct trial metadata was not provided");
    return null;
  }
  let currentDateTime = altCurrentDateTime;
  // If no current DateTime is passed, create one here
  if (!currentDateTime) {
    currentDateTime = DateTime.now().setZone(trialMetadata.timeZone);
  }

  const expirationDateTime = DateTime.fromFormat(trialMetadata.trialEndDate, "yyyy-MM-dd");
  const timeLeft = expirationDateTime.diff(currentDateTime, ["days"]);

  return timeLeft;
};

export const getDaysLeftOnTrial = (org: ISchema.IOrg, altCurrentDateTime?: DateTime) => {
  const trialInfo = getTrialMetadataFromOrg(org);
  const durationRemainingOnTrial = getCurrentDurationRemainingOnTrial(
    trialInfo,
    altCurrentDateTime,
  );

  return durationRemainingOnTrial ? Math.ceil(durationRemainingOnTrial.days) : null;
};
